import React from 'react';
import HubvexLoader from './HubvexLoader';

type Props = {
    text?: string;
};

const LoadingScreen: React.FC<Props> = ({ text }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-white/90 backdrop-blur-sm z-50">
            <HubvexLoader text={text} />
        </div>
    );
};

export default LoadingScreen;